import { Cohort } from "@/features/cohorts/types/cohorts";

export enum BusinessCategory {
  Builder = "Builder",
  Automator = "Automator",
  Educator = "Educator",
  Creative = "Creative",
}

export interface Mentor {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  auth0Id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  bio?: string;
  calendarLink?: string;
  referralCode?: string;
}

export interface CurrentUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  hash: string;
  stripeCustomerId: string;
  subscriptionActive: boolean;
  stripeActive: boolean;
  welcomeEmailSent: boolean;
  country: string;
  auth0Id: string;
  stripeId: string;
  stripeSubscriptionId: string;
  subscriptionValidUntil?: string;
  nonAIFounder?: boolean; // Legacy tracking only
  onboarded: boolean;
  mentor?: Mentor;
  cohort?: Cohort;
  // Payment related fields
  isDownpayment: boolean;
  isDownpaymentPaid: boolean;
  // Manual milestone tracking fields (managed by backend)
  completedTraining?: boolean;
  demoCompleted?: boolean;
  landingPageSetup?: boolean;
  testimonialsCount?: number;
  // New Stack Certified milestones
  niche?: string;
  nicheWho?: string;
  nicheWhat?: string;
  businessCategory?: string[]; // lowercase: ["builder", "automator", "educator", "creative"]
  expertise?: string;
  calendarLink?: string;
  // Stack Landing Page fields
  profilePhoto?: string;
  title?: string;
  location?: string;
  hourlyRate?: number;
  bio?: string;
  aboutMe?: string;
  skills?: string[];
  referralCode?: string;
  // Progression tracking (managed by admin)
  hasSharedDemo?: boolean;
  hasCompletedPlaybook?: boolean;
  hasLandingPage?: boolean;
  // Level and Certificate
  level?: "starter" | "certified" | "pro" | "x";
  certificateUrl?: string | null;
  // Announcement tracking
  hasSeenAgentsLibraryAnnouncement?: boolean;
  // Feature flags
  leadFinderEnabled?: boolean;
  // Subscription cancellation (STA-743). Populated when the founder (or an
  // admin) cancels via the Danger Zone flow. Drives `isCancelled` in
  // DangerZoneSection — when present, the section shows the "will end on"
  // copy and hides the Cancel button.
  subscriptionCancellationRequestedAt?: string;
  subscriptionCancellationReason?:
    | "too_expensive"
    | "not_using"
    | "better_alternative"
    | "missing_features"
    | "other";
  subscriptionEndsAt?: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}
